import { ActionContext, Module } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface NfrServiceStoreState {
}

export default {
  state : {
  },
  mutations : {
  },
  actions : {
    getNFRList(context : ActionContext<NfrServiceStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root : true });
      const endPoint = 'nfr/get-serial-number-history';
      return ApiServiceWrapper.get(endPoint);
    },
    processNFR(context : ActionContext<NfrServiceStoreState, RootStoreState>, payload : any) {
      context.commit('startLoading', null, { root : true });
      const endPoint = 'nfr/process-nfr';
      return ApiServiceWrapper.post(endPoint, payload);
    },
    getNFRHistory(context : ActionContext<NfrServiceStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root : true });
      const endPoint = 'nfr/get-nfr-history';
      return ApiServiceWrapper.get(endPoint);
    },
  },
  getters : {
  },
  namespaced :  true,
} as Module<NfrServiceStoreState, RootStoreState>;
